
export function who_is_navigation_mobile(){

    let css_is_navigation_mobile = getComputedStyle(document.querySelector('body') ).getPropertyValue('--who--js--is-navigation-mobile') ;

    if( 'true' === String( css_is_navigation_mobile ) ){
        return true ;
    }

    return  false;
}


export function who_get_css_device(){

    let device = false ;

    let css_device = getComputedStyle(document.querySelector('body') ).getPropertyValue('--who--js--device') ;

    if( '' != String( css_device ) ){
        return String( css_device ) ;
    }


    return device ;
}

export function who_is_object( objValue ){

    return objValue && typeof objValue === 'object' && objValue.constructor === Object ;
}



// https://codeforgeek.com/throttle-function-javascript/

export function who_throttle (fn, delay) {

    let lastCalled = 0;
    return (...args) => {
        let now = new Date().getTime();
        if(now - lastCalled < delay) {
            return;
        }
        lastCalled = now;
        return fn(...args);
    }
}